<div class="flex flex-col items-center gap-4 px-4 py-12 bg-white rounded-lg">
  <div
    class="size-20 flex items-center justify-center rounded-full mx-auto"
    [class]="getIconClasses()"
  >
    @if (icon(); as iconName) {
      <mat-icon>{{ iconName }}</mat-icon>
    } @else {
      <mat-icon>
        <ng-content select="icon"></ng-content>
      </mat-icon>
    }
  </div>

  <div class="text-center max-w-prose">
    @if (heading(); as headingText) {
      <h3 class="font-medium text-xl text-gray-800 text-balance">
        {{ headingText }}
      </h3>
    } @else {
      <h3 class="font-medium text-xl text-gray-800 text-balance">
        <ng-content select="heading"></ng-content>
      </h3>
    }

    @if (message(); as messageText) {
      <p class="text-sm text-gray-500 mt-1 text-pretty">
        {{ messageText }}
      </p>
    } @else {
      <p class="text-sm text-gray-500 mt-1 text-pretty">
        <ng-content select="message"></ng-content>
      </p>
    }
  </div>

  <ng-content select="button"></ng-content>
</div>
